// extracted by mini-css-extract-plugin
export default {"mainContainer":"PurchasePage_mainContainer__1jHSw","container":"PurchasePage_container__opyZ-"};